// Follow the existing administrative profile rules used by the sidebar.
export const canAccessCrm = user => user?.profile === "admin";
const crmPaths = ["/crm", "/kanban", "/tagskanban", "/reports", "/contact-lists", "/campaigns", "/campaign", "/campaigns-config", "/phrase-lists"];
export const isCrmPath = (pathname = "", search = "") => {
  const normalized = pathname.toLowerCase();
  return crmPaths.some(root => normalized === root || normalized.startsWith(root + "/")) || (["/", "/dashboard"].includes(normalized) && new URLSearchParams(search).get("tab")?.toUpperCase() === "NPS");
};
